import type { BoxProps } from '@mui/material/Box';

import { useId, forwardRef } from 'react';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export type LogoProps = BoxProps & {
  href?: string;
  isSingle?: boolean;
  disableLink?: boolean;
};

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    { width, href = '/', height, isSingle = true, disableLink = false, className, sx, ...other },
    ref
  ) => {
    const theme = useTheme();

    const gradientId = useId();

    const TEXT_PRIMARY = theme.vars.palette.text.primary;
    const PRIMARY_LIGHT = theme.vars.palette.primary.light;
    const PRIMARY_MAIN = theme.vars.palette.primary.main;
    const PRIMARY_DARKER = theme.vars.palette.primary.dark;

    // Resim dosyası kullanarak logo tanımlama
    const singleLogo = (
      <Box
        alt="Optimind Logo"
        component="img"
        src="/assets/images/optimind_logo.png"
        width="100%"
        height="100%"
        sx={{ objectFit: 'contain' }}
      />
    );

    const fullLogo = (
      <Box
        alt="Optimind Logo"
        component="img"
        src="/assets/images/optimind_logo.png"
        width="100%"
        height="100%"
        sx={{ objectFit: 'contain' }}
      />
    );

    const baseSize = {
      width: width ?? 160, // 140'tan 160'a çıkardım
      height: height ?? 160, // 140'tan 160'a çıkardım
      ...(!isSingle && {
        width: width ?? 350, // 400'den 350'ye düşürdüm
        height: height ?? 100, // 120'den 100'e düşürdüm
      }),
    };

    return (
      <Box
        ref={ref}
        component={RouterLink}
        href={href}
        className={logoClasses.root.concat(className ? ` ${className}` : '')}
        aria-label="Logo"
        sx={{
          ...baseSize,
          flexShrink: 0,
          display: 'inline-flex',
          verticalAlign: 'middle',
          justifyContent: 'center', // Ortalama için geri eklendi
          alignItems: 'center', // Ortalama için geri eklendi
          ...(disableLink && { pointerEvents: 'none' }),
          ...sx,
        }}
        {...other}
      >
        {isSingle ? singleLogo : fullLogo}
      </Box>
    );
  }
);
